import { environment } from '../environments/environment';

/**
 * Deshabilita console.log, console.debug, console.info y console.warn en producción
 * Mantiene console.error activo para errores críticos
 */
export function disableConsoleInProduction(): void {
  if (environment.production) {
    // Guardar las funciones originales (por si acaso se necesitan en el futuro)
    const originalLog = console.log;
    const originalDebug = console.debug;
    const originalInfo = console.info;
    const originalWarn = console.warn;

    // Sobrescribir console.log, console.debug, console.info y console.warn con funciones vacías
    console.log = function(): void {};
    console.debug = function(): void {};
    console.info = function(): void {};
    console.warn = function(): void {};

    // Opcional: mantener console.error activo para errores críticos
    // console.error se mantiene sin cambios
  }
}
